<template>
  <div>
    <Banner type="order" />
    <div class="page-container j-container-box-shadow container">
      <div class="title">
        <div class="title-section">
          <span
            @click="handleTabChange(1)"
            class="title-span"
            :class="{
              'title-selected j-title': tab === 1,
              'j-sub-title': tab !== 1
            }"
          >
            {{ $t('order.part_title') }}
          </span>

          <a-divider type="vertical" style="height: 28px; margin: 0 50px;" />

          <span
            @click="handleTabChange(2)"
            class="title-span"
            :class="{
              'title-selected j-title': tab === 2,
              'j-sub-title': tab !== 2
            }"
          >
            {{ $t('order.vehicle_title') }}
          </span>
<!-- 
          <a-divider type="vertical" style="height: 28px; margin: 0 50px;" />

          <span
            @click="handleTabChange(3)"
            class="title-span"
            :class="{
              'title-selected j-title': tab === 3,
              'j-sub-title': tab !== 3
            }"
          >
            {{ $t('order.logistics_title') }}
          </span> -->
        </div>

        <div class="action-section" @click="handleDownload">
          <DownloadIcon class="icon" />
          <span class="action-label">{{ $t('order.download') }}</span>
        </div>
      </div>

      <a-divider style="margin-top: 0;" />

      <div v-show="tab === 1">
        <PartOrder ref="partOrder" :moneyTypes="moneyTypes" />
      </div>

      <div v-show="tab === 2">
        <VehicleOrder ref="vehicleOrder" :moneyTypes="moneyTypes" />
      </div>

      <!-- <div v-show="tab === 3">
        <LogisticsOrder />
      </div> -->
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { mapState } from 'vuex';
import Banner from '@/components/banner/Banner.vue';
import DownloadIcon from '@/components/icons/DownloadIcon.vue';
import VehicleOrder from './VehicleOrder.vue';
import PartOrder from './PartOrder.vue';
import LogisticsOrder from './LogisticsOrder.vue';
import { getInternaion } from '@/api/apis';
import { downloadFile } from '@/api/request';
import { baseUrl } from '@/utils/constants';

export default defineComponent({
  name: 'Order',
  components: {
    Banner,
    DownloadIcon,
    VehicleOrder,
    PartOrder
    //LogisticsOrder
  },
  data() {
    return {
      tab: 1,
      moneyTypes: []
    };
  },
  created() {
    this.loadData();
  },
  computed: {
    ...mapState(['lang', 'userInfo'])
  },
  methods: {
    async handleDownload() {
      if (this.tab === 1 || this.tab === 2) {
        const params =
          this.tab === 1
            ? (this.$refs['partOrder'] as any).getFilter()
            : (this.$refs['vehicleOrder'] as any).getFilter();
        const paramArr: string[] = [];

        Object.keys(params).forEach(k => {
          const str = `${k}=${params[k]}`;

          paramArr.push(str);
        });

        paramArr.push(`customerId=${this.userInfo.id}`);
        paramArr.push(`locale=${this.lang}`);
        paramArr.push('moneyType=$');
        const orderType = this.tab == 1 ? 2 : this.tab == 2 ? 1 : this.tab;
        await downloadFile(
          `${baseUrl}ureport/excel?_u=db:user_order_export.ureport.xml&orderType=${orderType}&${paramArr.join(
            '&'
          )}`,
          this.tab === 1
            ? this.$t('order.part_title') + '.xlsx'
            : this.$t('order.vehicle_title') + '.xlsx',
          null
        );
      } else {
        // 物流
        const paramArr: string[] = [];
        paramArr.push(`customerId=${this.userInfo.id}`);
        paramArr.push(`locale=${this.lang}`);
        await downloadFile(
          `${baseUrl}ureport/excel?_u=db:user_logistics_list_excel.ureport.xml&${paramArr.join(
            '&'
          )}`,
          this.$t('order.logistics_title') + '.xlsx',
          null
        );
      }
    },
    async loadData() {
      const res = await getInternaion({ type: 8 }); // 货币;

      if (res.success) {
        this.moneyTypes = res.result || [];
      }
    },
    handleTabChange(tab) {
      this.tab = tab;

      this.$router.push(`/order?tab=${this.tab}`);
    }
  },
  watch: {
    $route: {
      immediate: true,
      handler(val) {
        if (val.name === 'Order') {
          const tab = +val.query.tab;
          if (tab && !isNaN(tab) && [1, 2, 3].includes(tab)) {
            this.tab = tab;
          } else {
            this.$router.push(`/order?tab=${this.tab}`);
          }
        }
      }
    }
  }
});
</script>

<style lang="scss" scoped>
.container {
  padding: 0 49px;
  background-color: white;

  .title {
    display: flex;
    align-items: center;
    height: 108px;
    justify-content: space-between;

    .title-section {
      display: flex;
      align-items: center;

      .title-span {
        position: relative;
        cursor: pointer;
        padding: 32px 0 29px 0;
        &:not(.title-selected) {
          color: $primary-secondary-forecolor;
          font-weight: bold;
        }

        &.title-selected {
          transition: all 0.5s;
          &::after {
            display: block;
            content: '';
            width: 100%;
            height: 4px;
            background: $primary-color;
            bottom: 0;
            position: absolute;
          }
        }
      }
    }

    .action-section {
      display: flex;
      align-items: center;
      cursor: pointer;
      color: $primary-color;
      .action-label {
        margin-left: 10px;
      }

      &:hover {
        color: $primary-hover-color;
      }
    }
  }
}
</style>
